//Built-in libraries
import type { ColumnDef } from '@tanstack/react-table';
import { useState } from 'react';
//Custom components
import Table from '@/components/UI/Table';

//Services

import Button from '@/components/UI/Button';
import Card from '@/components/UI/Card/index.tsx';
//Assets and Miscellaneous
import { CurrencyFormatDisplay } from '@/components/UI/NumberFormatDisplay/CurrencyFormatDisplay';

const impactByCountyWidgetData = [
  {
    id: 1,
    countyCode: '1',
    countyName: 'Allegany',
    totalGrants: 3355534,
    totalProjects: 19,
  },
  {
    id: 2,
    countyCode: '2',
    countyName: 'Anne Arundel ',
    totalGrants: 4556732,
    totalProjects: 10,
  },
  {
    id: 3,
    countyCode: '3',
    countyName: 'Baltimore City',
    totalGrants: 8567733,
    totalProjects: 13,
  },
  {
    id: 4,
    countyCode: '4',
    countyName: 'Baltimore',
    totalGrants: 8507700,
    totalProjects: 23,
  },
  {
    id: 5,
    countyCode: '5',
    countyName: 'Caroline',
    totalGrants: 6080713,
    totalProjects: 8,
  },
  {
    id: 6,
    countyCode: '6',
    countyName: 'Howard',
    totalGrants: 4556773,
    totalProjects: 9,
  },
  {
    id: 7,
    countyCode: '7',
    countyName: 'Cecil',
    totalGrants: 1006773,
    totalProjects: 6,
  },
];

const ImpactByCountyWidget = () => {
  const [perPage, setPerPage] = useState<number>(10);
  const [page, setPage] = useState<number>(1);
  const [totalPage, _setTotalPage] = useState<number>(1);

  const nextPageHandler = () => {
    setPage((prevState) => (prevState === totalPage ? totalPage : page + 1));
  };

  const previousPageHandler = () => {
    setPage((prevState) => (prevState > 1 ? page - 1 : 1));
  };

  const tableColumns: ColumnDef<any>[] = [
    {
      id: 'countyCode',
      header: 'County Code',
      accessorKey: 'countyCode',
      cell: (props) => {
        const { getValue } = props;
        const value = getValue() as string;
        if (value.trim() === '') {
          return 'Unknown';
        }
        return value;
      },
    },
    {
      id: 'countyName',
      header: () => <div className='text-center'>County Name</div>,
      accessorKey: 'countyName',
      cell: (props) => {
        const { getValue } = props;
        return (
          <div className='text-center'>
            <span>{getValue() as string}</span>
          </div>
        );
      },
    },
    {
      id: 'totalGrants',
      header: () => <div className='text-center'>Total Grants</div>,
      accessorKey: 'totalGrants',
      cell: (props) => {
        const { getValue } = props;
        return (
          <div className='text-center'>
            <CurrencyFormatDisplay value={getValue() as number} prefix='$' />
          </div>
        );
      },
    },
    {
      id: 'totalProjects',
      header: () => <div className='text-center'>Total Projects</div>,
      accessorKey: 'totalProjects',
      cell: (props) => {
        const { getValue } = props;
        return (
          <div className='text-center'>
            <span>{getValue() as number}</span>
          </div>
        );
      },
    },
  ];

  const tablePagination = {
    page: page,
    pageSize: perPage,
    pageCount: totalPage,
    currentPage: page,
    setPageSize: (v: number) => setPerPage(v),
    nextPage: nextPageHandler,
    previousPage: previousPageHandler,
  };

  return (
    <Card
      title='Impact By County'
      titleElement={
        <div className='flex justify-center gap-2'>
          <Button label='Map View' btnStyle='btn-neutral' btnType='button' />
          <Button label='List View' btnStyle='btn-primary' btnType='button' />
        </div>
      }
    >
      {impactByCountyWidgetData && (
        <div className='h-full w-full'>
          <div className='h-96 border rounded-b-md w-full'>
            <Table cols={tableColumns} tableData={impactByCountyWidgetData} pagination={tablePagination} height='h-5/6' />
          </div>
        </div>
      )}
    </Card>
  );
};

export default ImpactByCountyWidget;
